(function () {
  'use strict';

  if (customElements.get('goes-great-together')) return;

  /**
   * <goes-great-together> — one-tap add buttons on the "Goes Great Together"
   * cross-sell strip. Same proven plumbing as cart-cro-add.js: a single
   * /cart/add request with a sections payload, then the cart drawer is
   * repainted through <cart-drawer>.renderContents() (which also opens it).
   */

  function requestConfig() {
    if (typeof window.fetchConfig === 'function') return window.fetchConfig();
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    };
  }

  function cartRoute(name, fallback) {
    var routes = window.routes || {};
    return routes[name] || fallback;
  }

  function sectionIdsFor(drawer) {
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
    return drawer.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  // Resolves with the parsed cart response, rejects on any failure shape
  // (HTTP error, `{ status, message }`, or `{ errors }`).
  function postJSON(url, payload) {
    var config = requestConfig();
    config.body = JSON.stringify(payload);
    return fetch(url, config).then(function (response) {
      return response.json().then(function (body) {
        if (!response.ok || !body || body.status || body.errors) {
          throw new Error('cart-request-failed');
        }
        return body;
      });
    });
  }

  function setBusy(button, isBusy) {
    if (!button) return;
    button.toggleAttribute('disabled', isBusy);
    button.classList.toggle('is-loading', isBusy);
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  customElements.define(
    'goes-great-together',
    class GoesGreatTogether extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      showError(message) {
        var errorElement = this.querySelector('[data-ggt-error]');
        if (errorElement) errorElement.textContent = message;
      }

      onClick(event) {
        var button = event.target.closest('[data-ggt-add]');
        if (!button || !this.contains(button)) return;

        var variantId = button.dataset.variantId;
        if (!variantId) return;

        event.preventDefault();
        this.showError('');
        setBusy(button, true);

        var host = this;
        var drawer = document.querySelector('cart-drawer');

        var payload = { items: [{ id: variantId, quantity: 1 }] };
        if (drawer) {
          payload.sections = sectionIdsFor(drawer);
          payload.sections_url = window.location.pathname;
        }

        postJSON(cartRoute('cart_add_url', '/cart/add'), payload)
          .then(function (state) {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
                source: 'goes-great-together',
                cartData: state,
              });
            }

            setBusy(button, false);

            if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
              drawer.renderContents(state);
            }
          })
          .catch(function () {
            setBusy(button, false);
            host.showError(window.cartStrings && window.cartStrings.error ? window.cartStrings.error : 'Something went wrong. Please try again.');
          });
      }
    }
  );
})();
